import styled from 'styled-components';
import { COLOR_GREEN } from '../../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';
import BalanceAlert from '../../balance-alert';

export default styled.div`
  .columns {
    content: '';
    display: table;
    clear: both;
    width: 100%;
  }
  .column {
    width: 50%;
    float: left;
    min-height: 160px;
  }

  .d-block {
    display: block;
  }

  .modal-loading-wrap {
    margin-top: 24px;
    padding: 4px 20px;
    border: 1px solid rgba(47, 46, 65, 0.2);
    border-radius: 12px;
  }
  .align-right {
    float: right;
  }
  .vertical-align {
    display: flex;
    flex-direction: row;
    text-align: left;
    align-items: center;
  }
  .top-text-wrap {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
    align-items: center;
    h2 {
      max-width: 100%;
    }
  }
  .checkbox-wrap {
    padding-top: 24px;
    .hint {
      padding-top: 15px;
    }
  }
  .price-wrap {
    padding-top: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;

    h2 {
      max-width: 100%;
      color: ${COLOR_GREEN};
      line-height: 90px;
      font-size: 72px;
      font-weight: 900;
    }
  }

  .loan-summary-wrap {
    margin-top: 24px;
    padding: 24px;
    border: 1px solid rgba(47, 46, 65, 0.2);
    border-radius: 12px;

    &--bottom {
      padding-top: 0px;
      display: flex;
      flex-direction: row;
      &__row {
        padding-bottom: 10px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        &:last-child {
          padding-bottom: 0px;
        }
      }
    }
  }

  .submit-wrap {
    margin-top: 48px;
    button {
      width: 100%;
    }
  }

  .qr-code-placeholder {
    width: 150px;
    height: 150px;
    outline: 1px solid rgba(47, 46, 65, 0.2);
    border-radius: 8px;
    margin: 10px 10px 16px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    &.p5 {
      padding: 5px;
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    .price-wrap {
      padding-top: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;

      h2 {
        font-size: 45px;
        line-height: 50px;
      }
    }
    .column {
      width: 100%;
      text-align:center .d-block {
        width: 100%;
      }
    }
  }
`;

export const DepositAlert = styled(BalanceAlert)`
  padding: 20px 40px;
`;
